module.exports = __webpack_public_path__ + "img/trend-after-2.bb79aeb3.png";